/**
 * @file TaskHistoryList.tsx
 * @description История задачи в окне (phase19.31, crm.md T3–T5): создание,
 * назначения, автоматическое снятие исполнителя, выполнение — кто и когда.
 * Старые записи сверху; время — по поясу магазина.
 */

import type { ActivityDto } from "../../../lib/api-crm";
import { dayTimeInZone, historyEntryText, taskHistory } from "./task-texts";

interface Props {
  task: ActivityDto;
  timeZone: string;
}

export function TaskHistoryList({ task, timeZone }: Props) {
  const lines = [
    { at: task.createdAt, text: `Создана${task.createdByName ? ` · ${task.createdByName}` : ""}` },
    ...taskHistory(task).map((entry) => ({ at: entry.at, text: historyEntryText(entry) })),
  ];
  return (
    <ol aria-label="История задачи" className="flex flex-col gap-2">
      {lines.map((line, index) => (
        <li key={`${line.at}-${index}`} className="flex flex-col gap-0.5 sm:flex-row sm:gap-3">
          <span className="type-caption shrink-0 tabular-nums text-on-surface-variant sm:w-28">{dayTimeInZone(line.at, timeZone)}</span>
          <span className="type-body text-on-surface">{line.text}</span>
        </li>
      ))}
    </ol>
  );
}
